import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import MotosTable from "../../components/Tables/MotosTable";
import ManagementPageHero from "../../components/ManagementPageHero";
class Motos extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewVehiclePermission = userPermissions.includes('new vehicle');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Araçlar"
                Breadcrumb={[
                  {name: "Motosikletler", navigate: "motos"},

                ]}
            />
            <ManagementPageHero
              eyebrow="MOTOSİKLET YÖNETİMİ"
              title="Kayıtlı motosikletleri yönetin"
              description="Motosiklet ve müşteri bağlantılarını tek ekranda görüntüleyin, yeni kayıtları hızla oluşturun."
              actionTo={userHasNewVehiclePermission ? "/moto-add" : null}
              actionLabel="Yeni motosiklet"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Motosikletler</h2>
                    {userHasNewVehiclePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="moto-add">Yeni Motosiklet Ekle</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <MotosTable>

                    </MotosTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
                `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Motos));
